import request from '@/utils/request'

export function queryFeeDetail(params) {
  return request({
    url: '/fee.queryFeeDetail',
    method: 'get',
    params
  })
}

export function generatorReceipt(data) {
  return request({
    url: '/receipt.generatorReceipt',
    method: 'post',
    data
  })
}

// 查询缴费历史月份汇总
export function queryFeeDetailSummary(params) {
  return request({
    url: '/fee.queryFeeDetailSummary',
    method: 'post',
    data: params
  })
}